import { BrowserCacheLocation } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
      clientId: process.env.REACT_APP_AAD_CLIENT_ID as string,  //Application ID in Azure App Registration
      authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AAD_TENANT_ID}`,  //Tenant ID
      redirectUri: process.env.REACT_APP_AAD_REDIRECT_URL  as string,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
      storeAuthStateInCookie: false,
    }
  };
  
  // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
  export const loginRequest = {
   scopes: [`api://${process.env.REACT_APP_AAD_CLIENT_ID}/access_as_user`]
  };
  
  // Add the endpoints here for Microsoft Graph API services you'd like to use.
  export const graphConfig = {
      graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
  };

  export enum AppRoles {
    Visitors = "Visitors",
    Administrator = "Administrator"
  };


  //https://docs.microsoft.com/en-us/azure/active-directory/develop/tutorial-v2-react
  //https://docs.microsoft.com/en-us/azure/active-directory/develop/scenario-spa-app-registration#redirect-uri-msaljs-20-with-auth-code-flow
  //https://medium.com/sopra-steria-norge/msal-react-automatically-sign-in-users-and-get-app-roles-30893449ed87